<template>
  <div id="app">
    <router-view />
    <AuthHandler @auth-success="handleAuthSuccess" />
  </div>
</template>

<script>
import AuthHandler from '@/components/auth/AuthHandler.vue';

export default {
  name: 'App',
  components: {
    AuthHandler
  },
  methods: {
    handleAuthSuccess() {
      // Refresh the current route to reload data after successful authentication
      console.log('Authentication successful, refreshing current route');
      
      // Dispatch a custom event to notify components that auth was successful
      window.dispatchEvent(new CustomEvent('auth-success'));
      
      // Get the current route
      const currentRoute = this.$route;
      
      // Navigate to the same route to trigger a refresh
      this.$router.replace({
        name: currentRoute.name,
        params: currentRoute.params,
        query: currentRoute.query
      });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  overflow: hidden;
}
</style>